import { ChangeDetectionStrategy, Component, forwardRef, Inject, NgModuleRef } from '@angular/core';
import { IMODALS_SERVICE, IModalsService } from '@platform500services/p500-ui-kit';
import { FormWithHintAbstract } from '../../abstract/form-with-hint.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'gtd-image-with-hint',
  templateUrl: './image-with-hint-uploader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ImageWithHintUploaderComponent),
    },
  ],
})
export class ImageWithHintUploaderComponent extends FormWithHintAbstract {
  constructor(@Inject(IMODALS_SERVICE) public modalsService: IModalsService, moduleRef: NgModuleRef<any>) {
    super(modalsService, moduleRef);
  }
}
